import SimpleLightbox from 'simplelightbox';

export class CompanyGallery {
  constructor() {
    document.querySelectorAll('.s-company-gallery__grid').forEach((grid) => {
      new SimpleLightbox(grid.querySelectorAll('.s-company-gallery__item'), {
        captionsData: 'data-alt',
        captionDelay: 250,
        nav: true,
        showCounter: true,
      });
    });
  }
}
